import {MP_SEARCH_DRAFT_ORDERS_COMPLETE} from '../actions/actionTypes';
import initialState from './initialState';

export default function update(state = initialState.draftOrders, action) {
  if (action.type === MP_SEARCH_DRAFT_ORDERS_COMPLETE) {
    return action.payload.draftOrders;
  } else {
    return state;
  }
}
